// 看料首页静态展示数据（未接接口，仅供页面排版展示）

export interface HotChip {
  name: string;
  heat: number;
}

// 首屏多卡并列 · 精选直达
export interface FeaturedCard {
  icon: string;
  title: string;
  desc: string;
  meta: string;
  accent: 'amber' | 'orange' | 'rose' | 'emerald' | 'stone';
}

export const featuredCards: FeaturedCard[] = [
  {
    icon: 'ri-movie-2-line',
    title: '影音合集入口',
    desc: '影视、番剧、综艺一次列齐，分类直点少翻页',
    meta: '今日更 128 条',
    accent: 'orange',
  },
  {
    icon: 'ri-cloud-line',
    title: '网盘资源站',
    desc: '网盘与直链聚合，文件名即关键词，存下慢慢看',
    meta: '新收录 46 站',
    accent: 'emerald',
  },
  {
    icon: 'ri-article-line',
    title: '图文内容社区',
    desc: '长文、短评、合集贴集中汇总，一页逛完不迷路',
    meta: '在看 8.9k',
    accent: 'amber',
  },
  {
    icon: 'ri-tools-line',
    title: '效率工具集合',
    desc: '转换、下载、检索、排版小工具随手取用',
    meta: '维护 96 款',
    accent: 'rose',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: '每日精选推荐',
    desc: '人工筛过的高分内容与直达入口，换着看不重复',
    meta: '每日 20:30 更新',
    accent: 'stone',
  },
];

// 话题墙 · 大家都在搜
export const topicWall: string[] = [
  '今日热播榜',
  '高分冷门片',
  '经典老番合集',
  '生肉熟肉对照',
  '无删减原版',
  '中字搬运站',
  '4K 资源库',
  '弹幕互动版',
  '榜单常驻站',
  '冷门挖掘机',
  '剧场版专场',
  '连载跟更页',
  '剧情向解说',
  '实景跟拍',
  '同人创作集',
  '幕后花絮库',
  '评分聚合站',
  '多字幕切换',
  '夜间放映室',
  '一键追更',
];

export interface CatItem {
  name: string;
  flag?: '热' | '新' | '稳';
  desc: string;
}

export interface Category {
  icon: string;
  title: string;
  lead: string;
  items: CatItem[];
}

// 分区直达 · 话题墙式
export const categories: Category[] = [
  {
    icon: 'ri-video-on-line',
    title: '影音向',
    lead: '视频资源与内容入口，按方向挑，不用到处问',
    items: [
      { name: '影视聚合库', flag: '热', desc: '全网影视直链集合' },
      { name: '番剧跟更站', flag: '新', desc: '连载更新及时' },
      { name: '网盘直达组', desc: '转存即看的盘源' },
      { name: '短剧集散地', flag: '热', desc: '竖屏短剧大全' },
      { name: '直播源汇总', desc: '电视台直播入口' },
      { name: '高清修复馆', flag: '稳', desc: '老片高清重制' },
    ],
  },
  {
    icon: 'ri-image-2-line',
    title: '图文向',
    lead: '帖子、专栏、合集贴，适合碎片时间里读',
    items: [
      { name: '长文社区', desc: '深度内容交流区' },
      { name: '讨论组广场', flag: '热', desc: '热门话题跟帖' },
      { name: '合集整理库', desc: '按主题归档成贴' },
      { name: '同好主页墙', desc: '同好内容聚合' },
      { name: '评分点评站', flag: '新', desc: '口碑与长评集中' },
    ],
  },
  {
    icon: 'ri-search-eye-line',
    title: '检索向',
    lead: '跨站搜索与聚合，一个框找多个源',
    items: [
      { name: '聚合搜索器', flag: '热', desc: '多站一并检索' },
      { name: '文件精准搜', desc: '盘内文件名匹配' },
      { name: '热度趋势页', flag: '新', desc: '今日搜索趋势' },
      { name: '直达生成器', desc: '关键词转直达链接' },
    ],
  },
  {
    icon: 'ri-briefcase-4-line',
    title: '工具与服务',
    lead: '配合导航使用的实用小工具，随取随用',
    items: [
      { name: '格式转换台', flag: '稳', desc: '视频格式互转' },
      { name: '字幕处理站', desc: '字幕提取与对齐' },
      { name: '链接检测仪', flag: '新', desc: '失效入口体检' },
      { name: '收藏夹云同步', desc: '跨设备收藏' },
    ],
  },
];

// 此刻最热 TOP 榜
export interface RankItem {
  rank: number;
  name: string;
  tag: string;
  trend: number;
  viewers: string;
}

export const hotRanks: RankItem[] = [
  { rank: 1, name: '聚合搜索器', tag: '影音向', trend: 12, viewers: '36.2k' },
  { rank: 2, name: '影视聚合库', tag: '影音向', trend: 8, viewers: '31.5k' },
  { rank: 3, name: '番剧跟更站', tag: '影音向', trend: 5, viewers: '27.8k' },
  { rank: 4, name: '短剧集散地', tag: '影音向', trend: 3, viewers: '22.1k' },
  { rank: 5, name: '讨论组广场', tag: '图文向', trend: 2, viewers: '19.6k' },
  { rank: 6, name: '热度趋势页', tag: '检索向', trend: 1, viewers: '15.4k' },
  { rank: 7, name: '链接检测仪', tag: '工具', trend: 1, viewers: '12.8k' },
  { rank: 8, name: '高清修复馆', tag: '影音向', trend: 0, viewers: '10.3k' },
];

// 讨论区 · 留言墙（互动氛围展示）
export interface CommentItem {
  name: string;
  time: string;
  text: string;
  likes: number;
  color: string;
  initial: string;
}

export const commentFeed: CommentItem[] = [
  {
    name: '夜航星',
    time: '8 分钟前',
    text: '今天更新的「高清修复馆」把我一直在找的老番重制版收进去了，收藏夹又多一个省心入口。',
    likes: 128,
    color: 'bg-orange-200 text-orange-800',
    initial: '夜',
  },
  {
    name: '只吃饭不刷夜',
    time: '26 分钟前',
    text: '建议检索向再补个能按清晰度筛的开关，现在关键词一搜出来好多重复盘源。',
    likes: 76,
    color: 'bg-emerald-200 text-emerald-800',
    initial: '只',
  },
  {
    name: '一碗热汤',
    time: '1 小时前',
    text: '问个失效入口，之前收藏的短剧那个打不开了，麻烦补个新的，蹲一个更新。',
    likes: 54,
    color: 'bg-rose-200 text-rose-800',
    initial: '热',
  },
  {
    name: '信号满格',
    time: '2 小时前',
    text: '榜单里那个「聚合搜索器」确实好用，一个框串好几个源，省了来回切页面。',
    likes: 41,
    color: 'bg-amber-200 text-amber-800',
    initial: '信',
  },
];